import React from 'react';
import PropTypes from 'prop-types';
import ResponsiveTable from "../elements/ResponsiveTable";

const PlainTextv2 = (props) => {

	const renderList = data => data.map((value, key) => {
		return <li key={key} dangerouslySetInnerHTML={{__html: value}} />;
	});

	const Content = props.data.map((item, key) => {
		if (typeof(item) === 'string') {
			if (key === 0) {
				return props.excludeTitle ? '' : <h5 className="mb-2 mt-4 bold" key={key} dangerouslySetInnerHTML={{__html: item}} />;
			} else {
				return <p key={key} dangerouslySetInnerHTML={{__html: item}} />;
			}
		} else {
			if (item.type === 'list') {
				return <ul key={key} >{renderList(item.content)}</ul>;
			} else if (item.type === 'table') {
				return (
					<ResponsiveTable key={key} data={item.content} />
				);
			}
		}
	});

	return <div className={props.excludeTitle ? '' : 'mb-5'}>{Content}</div>;

};

PlainTextv2.propTypes = {
	data: PropTypes.array,
	excludeTitle: PropTypes.bool
};

export default PlainTextv2;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/PlainTextv2.js